export default "__VITE_ASSET__C_u$QQG2__"